<template>
  <main>
    <div class="pra_all">
      <Tou></Tou>
      <div class="dad">
        <ul class="routing">
          <li>
            <span @click="Instructions_YI" class="Instructions">常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions" @click="Instructions_ER"
              >账户常见问题</span
            >
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions current">VIP邀请返现说明</span>
            <!-- <div class="border_linear"></div> -->
          </li>
        </ul>
        <ul class="pra_content tong">
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>
                邀请用户如何返现?
              </div>
            </div>
            <div class="answer">
              <div class="da">答案:</div>
              <p>一、</p>
              <table style="border-collapse: collapse; width: 100%" border="1">
                <tbody>
                  <tr>
                    <td style="width: 25%" colspan="4">
                      <p style="text-align: center">
                        <strong>一、A用户vip3、B用户vip3、C用户vip0</strong
                        ><br /><strong>C用户首充50元</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">&nbsp;</td>
                    <td style="width: 25%; text-align: center">A用户</td>
                    <td style="width: 25%; text-align: center">B用户</td>
                    <td style="width: 25%; text-align: center">C用户</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">海星点</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">50</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">海星赠点</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">25</td>
                    <td style="width: 25%; text-align: center">25</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">奖励金（元）</td>
                    <td style="width: 25%; text-align: center">2.5</td>
                    <td style="width: 25%; text-align: center">2.5</td>
                    <td style="width: 25%; text-align: center">0</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: left" colspan="4">
                      备注：<br />当A用户邀请B用户
                      ，B用户充值到Vip3时，B用户邀请的C用户首次充值50元时；<br />A用户可以得到C用户充值金额的5%返现（即2.5元奖励金）；<br />B用户可以得到C用户充值金额的50%返点（即25海星赠点）+充值金额的5%返现（即2.5奖励金）；<br />C用户可得到充值金额的50%返点（即25海星赠点）。
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>&nbsp;</p>
              <p>二、</p>
              <table style="border-collapse: collapse; width: 100%" border="1">
                <tbody>
                  <tr>
                    <td style="width: 25%" colspan="4">
                      <p style="text-align: center">
                        <strong>二、A用户vip3、B用户vip3、C用户vip1</strong
                        ><br /><strong>C用户充值20元</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">&nbsp;</td>
                    <td style="width: 25%; text-align: center">A用户</td>
                    <td style="width: 25%; text-align: center">B用户</td>
                    <td style="width: 25%; text-align: center">C用户</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">海星点</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">20</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">海星赠点</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">奖励金（元）</td>
                    <td style="width: 25%; text-align: center">1</td>
                    <td style="width: 25%; text-align: center">1</td>
                    <td style="width: 25%; text-align: center">0</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: left" colspan="4">
                      备注1：<br />当A用户邀请B用户
                      ，B用户充值到Vip3时，B用户邀请的C用户充值20元时；<br />A用户可以得到C用户充值金额的5%返现（即1元奖励金）；<br />B用户可以得到C用户充值金额的5%返现（即1元奖励金）；<br />备注2：<br />一年内B用户和C用户充值，A用户均可按备注1条款，获得相应奖励金；<br />且奖励金累计到100元时可进行提现。<br />备注3：<br />奖励机制只涉及3个用户之间的关系（即A-B-C）。
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>&nbsp;</p>
              <p>三、</p>
              <table style="border-collapse: collapse; width: 100%" border="1">
                <tbody>
                  <tr>
                    <td style="width: 25%" colspan="4">
                      <p style="text-align: center">
                        <strong>三、A用户vip3、B用户vip0、C用户vip0</strong
                        ><br /><strong>C用户首充50元</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">&nbsp;</td>
                    <td style="width: 25%; text-align: center">A用户</td>
                    <td style="width: 25%; text-align: center">B用户</td>
                    <td style="width: 25%; text-align: center">C用户</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">海星点</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">50</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">海星赠点</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">奖励金（元）</td>
                    <td style="width: 25%; text-align: center">2.5</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: left" colspan="4">
                      备注：<br />当A用户邀请B用户
                      ，B用户未充值时，B用户邀请的C用户首次充值50元时；<br />A用户可以得到C用户充值金额的5%返现（即2.5元奖励金）；<br />B用户无任何奖励。
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>&nbsp;</p>
              <p>四、</p>
              <table style="border-collapse: collapse; width: 100%" border="1">
                <tbody>
                  <tr>
                    <td style="width: 25%" colspan="4">
                      <p style="text-align: center">
                        <strong>四、A用户vip3、B用户vip0、C用户vip1</strong
                        ><br /><strong>C 用户充值20元</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">&nbsp;</td>
                    <td style="width: 25%; text-align: center">A用户</td>
                    <td style="width: 25%; text-align: center">B用户</td>
                    <td style="width: 25%; text-align: center">C用户</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">海星点</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">20</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">海星赠点</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: center">奖励金（元）</td>
                    <td style="width: 25%; text-align: center">1</td>
                    <td style="width: 25%; text-align: center">0</td>
                    <td style="width: 25%; text-align: center">0</td>
                  </tr>
                  <tr>
                    <td style="width: 25%; text-align: left" colspan="4">
                      备注1：<br />当A用户邀请B用户
                      ，B用户未充值时，B用户邀请的C用户充值20元时；<br />A用户可以得到C用户充值金额的5%返现（即1元奖励金）；<br />B用户无任何奖励；<br />备注2：<br />一年内B用户和C用户充值，A用户均可按备注1条款，获得相应奖励金；<br />且奖励金累计到100元时可进行提现。<br />备注3：<br />一年内B用户充值到V3及以上，B用户也可享受备注1中
                      A用户奖励金条款；<br />且奖励金累计到100元时可进行提现。<br />备注4：<br />奖励机制只涉及3个用户之间的关系（即A-B-C）。
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import Tou from '@/components/Tou.vue'
export default {
  components: {Tou},
  data () {
    return {
    }
  },
  mounted () {},
  methods: {
    Instructions_YI () {
      this.$router.push('./faq')
    },
    Instructions_ER () {
      this.$router.push('./Account')
    }
  }
}
</script>

<style lang="scss" scoped>
.current {
  color: #ffffff94;
}
.current:hover {
  color: #ffffff94 !important;
}
html,
body {
  width: 100%;
  height: 100%;
}
.pra_all {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #100e2e;
}
.pra_content {
  width: 1070px;
  min-height: 300px;
  padding: 10px 20px 30px 20px;
  margin-top: 30px;
}
.dad {
  margin-top: 170px;
  background-color: #100e2e;
}
.title {
  font-size: 18.3px;
  color: #ffffff;
  width: 1070px;
  font-weight: 900;
}
.title div {
  // text-indent: 25px;
  display: inline-block;
}
.tong {
  margin: 15px auto 0;
  background-color: #0d0b26;
  padding-top: 30px;
}
.PC_li {
  padding: 5px 0 6px 0;
  margin-bottom: 25px;
}
.answer {
  // text-indent: 20px;
  font-size: 16px;
  // color: #ffffff9c;
  color: white;
  width: 100%;
  min-height: 100px !important;
  border-radius: 3px;
  margin-top: 15px;
  padding: 5px 30px;
  background-color: #252e45;
}
.answer div {
  display: inline-block;
}
.da {
  font-size: 16px;
  margin-bottom: 10px;
}
@media screen and (max-width: 1000px) {
  .tong {
    width: 100%;
  }
  .dad {
    margin-top: 100px;
    background-color: #100e2e;
  }
}
.routing {
  height: 20px;
  width: 1070px;
  margin-top: 70px;
  font-size: 12px;
  line-height: 20px;
  margin: 0 auto;
}
.routing li {
  display: inline;
  position: relative;
}
.Instructions:hover {
  color: white;
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  .routing {
    width: 100%;
  }
}
.border_linear {
  width: 100% !important;
  height: 1px !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(190, 187, 187, 0.1) 0%,
    rgba(190, 187, 187, 0.2) 10%,
    rgba(190, 187, 187, 0.3) 20%,
    rgba(190, 187, 187, 0.4) 30%,
    rgba(190, 187, 187, 0.5) 40%,
    rgba(190, 187, 187, 0.8) 50%,
    rgba(190, 187, 187, 0.5) 60%,
    rgba(190, 187, 187, 0.4) 70%,
    rgba(190, 187, 187, 0.3) 80%,
    rgba(190, 187, 187, 0.2) 90%,
    rgba(190, 187, 187, 0.1) 100%
  );
}
@media screen and (min-width: 999px) and (max-width: 1199px) {
  .dad {
    margin-top: 200px;
  }
}
@media screen and (min-width: 768px) and (max-width: 998px) {
  .dad {
    margin-top: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonProblem/Account/VipCashback.vue